import { Box, ButtonBase } from '@mui/material';
import React from 'react';
import { MessageMediaType, MessageStatus } from 'types/chat/messages/common';
import MediaPlaceholderWrapper from 'ui-component/display/MediaPlaceholderWrapper';
import LoupeOutlinedIcon from '@mui/icons-material/LoupeOutlined';
import { isValidUrl } from 'utils/helpers';
import FileUploadProgress from './FileUploadProgress';
import { MediaPreviewType } from 'types/chat/props';

const images = {
  pdf: '/images/file-types/pdf.png',
  docx: '/images/file-types/docx_icon.png',
  xlsx: '/images/file-types/xlsx.png',
  zip: '/images/file-types/zip.png',
};

interface LinkComponentProps {
  fileTypeImg: any;
  status: MessageStatus | null | undefined;
  handleMediaPreview: (params: Partial<MediaPreviewType>) => void;
  file: string;
  children?: React.ReactNode;
}
const PreviewComponent = ({ fileTypeImg, status, handleMediaPreview, file, children }: LinkComponentProps) =>
  fileTypeImg === images.pdf ? (
    <ButtonBase
      sx={{
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
        borderRadius: 1,
        overflow: 'hidden',
        position: 'relative',
        cursor: 'zoom-in',
      }}
      onClick={() =>
        status !== 'uploading' &&
        isValidUrl(file) &&
        handleMediaPreview({
          visible: true,
          file: file,
          type: 'pdf',
        })
      }
    >
      {children}
    </ButtonBase>
  ) : (
    <Box
      component={'a'}
      target="_blank"
      rel="noreferrer"
      href={file}
      sx={{
        width: '100%',
        height: '100%',
        display: 'block',
        borderRadius: 1,
        overflow: 'hidden',
        position: 'relative',
        cursor: 'zoom-in',
      }}
    >
      {children}
    </Box>
  );

interface DocMessageProps {
  file: string;
  fileType: MessageMediaType;
  mediaNoteFormat: string | null;
  object: string | null | undefined;
  status: MessageStatus | null | undefined;
  handleMediaPreview: (params: Partial<MediaPreviewType>) => void;
}

const DocMessage: React.FC<DocMessageProps> = ({
  file,
  fileType,
  mediaNoteFormat,
  object,
  status,
  handleMediaPreview,
}) => {
  let fileTypeImg = null;

  //* process 'document' file type
  if (fileType === 'document' || mediaNoteFormat === 'document') {
    let fileTypeImgCurrent: string | null | undefined = '';
    const splitFileName = object?.split('.');
    const fileExt = splitFileName?.[splitFileName.length - 1].toLowerCase();

    if (fileExt === 'pdf') {
      fileTypeImgCurrent = images.pdf;
    } else if (fileExt === 'docx' || fileExt === 'doc' || fileExt === 'msword') {
      fileTypeImgCurrent = images.docx;
    } else if (fileExt === 'xlsx' || fileExt === 'xls') {
      fileTypeImgCurrent = images.xlsx;
    } else if (fileExt === 'zip') {
      fileTypeImgCurrent = images.zip;
    } else if (fileExt === 'image' || fileExt?.match(/(png|jpe?g|gif)$/i)) {
      fileTypeImgCurrent = object;
    }
    // else if (fileExt?.match(/(mp4|webm|avi|mov|mkv|flv|wmv)$/i)) {
    //   fileTypeImgCurrent = object;
    // }

    fileTypeImg = fileTypeImgCurrent;
  } else {
    //* Process file type directly
    if (fileType === 'pdf' || mediaNoteFormat === 'pdf') {
      fileTypeImg = images.pdf;
    } else if (['docx', 'doc', 'msword'].includes(fileType as string) || ['docx', 'doc', 'msword'].includes(mediaNoteFormat as string)) {
      fileTypeImg = images.docx;
    } else if (fileType === 'xlsx' || fileType === 'xls' || mediaNoteFormat === 'xlsx' || mediaNoteFormat === 'xls') {
      fileTypeImg = images.xlsx;
    } else if (fileType === 'zip' || mediaNoteFormat === 'zip') {
      fileTypeImg = images.zip;
    }
  }

  return (
    <Box
      sx={{
        width: 110,
        height: 110,
        margin: '0 auto !important',
      }}
    >
      {/* <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
      }} /> */}
      <PreviewComponent
        file={file}
        fileTypeImg={fileTypeImg}
        status={status}
        handleMediaPreview={handleMediaPreview}
      >
        {status === 'uploading' && <FileUploadProgress interval={300} />}
        {status !== 'uploading' && isValidUrl(file) && (
          <MediaPlaceholderWrapper isWaitUpload={false}>
            <LoupeOutlinedIcon
              sx={{
                fontSize: 40,
              }}
            />
          </MediaPlaceholderWrapper>
        )}
        <Box
          component={'img'}
          src={fileTypeImg || ''}
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: 1,
            objectFit: 'contain',
          }}
        />
      </PreviewComponent>
    </Box>
  );
};

export default DocMessage;
